import React from 'react';
import { CONSTANTS } from '../../data';
import { ASSETS } from '../../assetManifest';
import { sounds } from '../../systems/AudioSystem';
import type { AssetsSchema } from '../../assetManifestTypes';

interface InstructionsScreenProps {
  onBack: () => void;
}

export const InstructionsScreen: React.FC<InstructionsScreenProps> = ({ onBack }) => {
  const typedAssets = ASSETS as AssetsSchema;
  const backgroundAsset = typedAssets.backgrounds?.main_menu_neural_network;

  return (
    <div
      className="menu-screen"
      style={{
        backgroundImage: backgroundAsset ? `url(${backgroundAsset.path})` : undefined,
      }}
    >
      <div className="menu-screen-content">
        <h2>{CONSTANTS.HOW_TO_PLAY_SCREEN.title}</h2>
        {CONSTANTS.HOW_TO_PLAY_SCREEN.content.map((text, i) => (
          <p key={i}>{text}</p>
        ))}
      </div>
      <button 
        className="menu-button mt-8" 
        onClick={() => {
          sounds.buttonClick();
          onBack();
        }}
        onMouseEnter={() => sounds.menuHover()}
      >
        {CONSTANTS.MAIN_MENU.backButtonText}
      </button>
    </div>
  );
};
